import { VesselTypes } from '@geckoal/gecko-api-client'

export type VesselTypeItem = {
    value: VesselTypes
    title: string
}

export const ALL_VESSEL_TYPES: VesselTypeItem[] = [
    {
        value: VesselTypes.Hottub,
        title: titleForVesselType(VesselTypes.Hottub)
    },
    {
        value: VesselTypes.Pool,
        title: titleForVesselType(VesselTypes.Pool)
    },
    {
        value: VesselTypes.Swimspa,
        title: titleForVesselType(VesselTypes.Swimspa)
    }
]

export function titleForVesselType(vesselType: VesselTypes | string): string {
    if (vesselType === VesselTypes.Pool) return 'Pool'
    if (vesselType === VesselTypes.Hottub) return 'Hot Tub'
    if (vesselType === VesselTypes.Swimspa) return 'Swim Spa'
    return vesselType
}
